// NL
export const homeBatteryNL = {
  id: '9c78e8ae-4397-4fd6-bf19-a7348f6ef2a5',
  identifier: 'home-battery-default',
}
